import { COLORS, STYLES, TYPOGRAPHY } from '@app/constants';
import { FC } from 'react';
import { MenuListProps } from 'react-select';
import styled from 'styled-components';

const MenuList: FC<MenuListProps> = ({ children, ...props }) => {
  return (
    <Root $isGroupSelect={props.selectProps.isGroupSelect}>{children}</Root>
  );
};

export default MenuList;

interface StyleProps {
  $isGroupSelect?: boolean;
}

const Root = styled.ul<StyleProps>`
  ${TYPOGRAPHY.body1Regular14}
  color: ${COLORS.grayscale700};
  margin-top: ${({ $isGroupSelect }) => $isGroupSelect && '15px'};
  overflow-y: auto;
  ${STYLES.scrollbar};
  max-height: 200px;
  overscroll-behavior: contain;
`;
